module.exports = __webpack_public_path__ + "img/dwg.f1728b6f.png";